import React from "react";

import { getLocalizedPath as getLocalizedPathHelper } from "@/utils/getLocalizedPath";

import { useExperience } from "./useExperience";

export const useLocalizedPath = () => {
  const { countryOptions, pathCountry, pathLanguage } = useExperience();

  const getLocalizedPath = React.useCallback(
    (href: string, localize = true) => {
      if (href.startsWith("/")) {
        const {
          countryCode,
          languageCode,
          pathname: pathnameInitial
        } = getLocalizedPathHelper(href, countryOptions);

        let pathname = "/~";

        if (!localize) {
          return pathname + href;
        }

        if (countryCode) {
          pathname = pathname + `/${countryCode.toLowerCase()}`;

          if (languageCode) {
            pathname = pathname + `/${languageCode.toLowerCase()}`;
          }
        } else if (pathCountry) {
          pathname = pathname + `/${pathCountry.iso2.toLowerCase()}`;

          const pathLanguageIndex = pathCountry.languages.findIndex(
            (languageOption) => languageOption.iso2 === pathLanguage?.iso2
          );

          if (pathLanguage && pathLanguageIndex > 0) {
            pathname = pathname + `/${pathLanguage.iso2}`;
          }
        }

        return `${pathname}${pathnameInitial}`;
      }

      return href;
    },
    [countryOptions, pathCountry, pathLanguage]
  );

  return {
    getLocalizedPath
  };
};
